export default class WMICRiskPublicIdUtil {
    static getPublicIdsFromList = listOfObjects => listOfObjects.map(object => object.publicID);

    static getAllRiskPublicIds = (...risks) => {
        const riskPublicIDs = [];
        risks.forEach(listofRisks => {
            if (listofRisks) {
                riskPublicIDs.push(WMICRiskPublicIdUtil.getPublicIdsFromList(listofRisks));
            }
        });
        return riskPublicIDs.flat().sort();
    };

    static doNewAndOldRiskPublicIdsMatch = (startingRiskPublicIds, ...newRisks) => {
        const newRiskPublicIds = WMICRiskPublicIdUtil.getAllRiskPublicIds(...newRisks);
        return newRiskPublicIds.toString() === startingRiskPublicIds.toString();
    };

    static hasNewRiskPublicIds = (startingRiskPublicIds, ...currentRisks) => {
        const currentRiskPublicIds = WMICRiskPublicIdUtil.getAllRiskPublicIds(...currentRisks);
        return !currentRiskPublicIds.every(publicId => startingRiskPublicIds.includes(publicId));
    };
}
